import React from "react";
var __jsx = React.createElement;
import TagInput from 'components/common/TagInput';
import { useTaxonomyTagOptions } from 'libs/content/hooks';
import generateTruncatedSections from 'libs/content/utils/generateTruncatedSections';

var TaxonomyField = function TaxonomyField(_ref) {
  var formField = _ref.formField;

  var _useTaxonomyTagOption = useTaxonomyTagOptions(formField.taxonomyName),
      loading = _useTaxonomyTagOption.loading,
      options = _useTaxonomyTagOption.options;

  return __jsx(TagInput, {
    labelId: formField.labelId,
    name: formField.name,
    options: options,
    multipleTag: formField.multiple,
    disabled: formField.disabled,
    showTitle: formField.disabled,
    loading: loading,
    formatLabel: generateTruncatedSections
  });
};

export default TaxonomyField;